import { Dialog, DialogPanel } from '@headlessui/react'
import React from 'react'

const ConfirmModal = ({
    open,
    onClose,
    onConfirm,
    title = "Are you sure?",
    message = "",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    confirmColor = "primary",
    panelClass,
    zIndexClass,
    children,
}) => {
    const confirmBtnColorMap = {
        danger: "bg-canvas-danger hover:bg-red-600",
        primary: "bg-canvas-primary hover:brightness-110",
        success: "bg-canvas-success hover:bg-green-700",
    }

    const confirmBtnClass = confirmBtnColorMap[confirmColor] || confirmBtnColorMap.danger

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={`relative ${zIndexClass ?? "z-[999]"}`}
        >
            {/* Backdrop */}
            <div className="fixed inset-0 bg-canvas-black/40 backdrop-blur-sm" aria-hidden="true" />

            <div className="fixed inset-0 flex items-center justify-center p-4">
                <DialogPanel
                    transition
                    className={`relative bg-white rounded-2xl shadow-2xl w-full duration-300 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 ${panelClass ?? "max-w-md"}`}
                >
                    {/* Close button */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-canvas-secondery hover:text-canvas-black transition-colors"
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    <div className="p-6 pt-8">
                        {/* Title */}
                        <h3 className="text-center text-lg font-semibold text-canvas-black font-outfit mb-2">
                            {title}
                        </h3>

                        {/* Message or custom children */}
                        <div className="text-center text-sm text-canvas-secondery font-outfit mb-6">
                            {children ?? message}
                        </div>

                        {/* Actions */}
                        <div className="flex gap-3">
                            <button
                                onClick={onConfirm ?? onClose}
                                className={`flex-1 rounded-xl py-2.5 text-sm font-medium text-white transition-colors font-outfit ${confirmBtnClass}`}
                            >
                                {confirmLabel}
                            </button>
                            <button
                                onClick={onClose}
                                className="flex-1 rounded-xl border border-canvas-tersery py-2.5 text-sm font-medium text-canvas-black hover:bg-gray-50 transition-colors font-outfit"
                            >
                                {cancelLabel}
                            </button>

                        </div>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    )
}

export default ConfirmModal
